// src/components/RichTextEditor.js
import React, { useState, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// Custom Toolbar Configuration
const customModules = {
  toolbar: {
    container: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      [{ color: [] }, { background: [] }],
      ["link", "image", "video"],
      ["clean"],
      ["attach"], // Custom attachment button
    ],
    handlers: {
      attach: function () {
        document.getElementById("fileInput").click();
      },
    },
  },
};

const RichTextEditor = () => {
  const [value, setValue] = useState("");
  const quillRef = useRef(null);

  const handleFileAttachment = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const fileURL = reader.result;
        const fileName = file.name;
        const fileLink = `<a href="${fileURL}" download="${fileName}" target="_blank">${fileName}</a>`;
        setValue((prevValue) => `${prevValue} ${fileLink}`);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="pt-4">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={setValue}
        modules={customModules}
        className="bg-white shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Type your content here..."
        ref={quillRef}
      />

      {/* Hidden File Input */}
      <input
        type="file"
        id="fileInput"
        onChange={handleFileAttachment}
        className="hidden"
      />

      {/* Preview Section */}
      {/* <div className="mt-4 p-2 border rounded-md bg-gray-50">
        <h3 className="font-semibold mb-2">Preview:</h3>
        <div className="prose max-w-full" dangerouslySetInnerHTML={{ __html: value }} />
      </div> */}
    </div>
  );
};

export default RichTextEditor;
